import { useCallback } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useLogoutSSOUser, useRevokeToken } from "./user/mutation";
import useAuthStore from "../store/Auth";
import { useTableStore } from "../store/Table";
import { AUTH_ROUTES } from "../routes";
import { useNavigate } from "react-router-dom";
import StatusCodes from "../constants/StatusCodes";

export const useLogoutUser = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const { mutateAsync: LogoutSSOUser } = useLogoutSSOUser();
  const { mutateAsync: RevokeToken } = useRevokeToken();

  const { user, reset } = useAuthStore();
  const { resetTableStore } = useTableStore();

  const logoutUser = useCallback(async () => {
    if (user?.isSSOLogin) {
      try {
        const { ssoLogoutUri } = await LogoutSSOUser();

        window.location.href = ssoLogoutUri;
      } catch (error) {
        toast.error(t("somethingWentWrong"));
        return;
      }
    } else {
      try {
        await RevokeToken();
      } catch (error: any) {
        if (error.statusCode !== StatusCodes.BAD_REQUEST) {
          toast.error(t("somethingWentWrong"));
        }
      }
    }

    sessionStorage.clear();
    reset();
    resetTableStore();

    navigate(AUTH_ROUTES.LOGIN);
  }, [LogoutSSOUser, RevokeToken, navigate, reset, resetTableStore, t, user?.isSSOLogin]);

  return { logoutUser };
};
